module.exports = __webpack_public_path__ + "img/minus-inactive.b9b8a99b.svg";